/**
 * request-item.js
 * Handles the "Request this item" modal for out-of-stock products.
 */

(function () {
  const overlay = document.getElementById('RequestItemOverlay');
  if (!overlay) return;

  const form = document.getElementById('RequestItemForm');
  const headingEl = document.getElementById('RequestItemTitle');
  const subheadingEl = document.getElementById('RequestItemSubheading');
  const productNameEl = document.getElementById('RequestItemProductName');
  const subjectInput = document.getElementById('RequestItemSubject');
  const bodyInput = document.getElementById('RequestItemBody');
  const nameInput = document.getElementById('RequestItemName');
  const nameError = document.getElementById('RequestItemNameError');
  const emailInput = document.getElementById('RequestItemEmail');
  const emailError = document.getElementById('RequestItemEmailError');
  const notesInput = document.getElementById('RequestItemNotes');
  const submitLabel = overlay.querySelector('.request-item-submit-label');
  const submitSending = overlay.querySelector('.request-item-submit-sending');
  const successEl = document.getElementById('RequestItemSuccess');

  let currentProductTitle = '';

  function escHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ------------------------------------------------------------------
  // Open / close
  // ------------------------------------------------------------------

  function openModal(productTitle, productHandle, isCustom) {
    currentProductTitle = productTitle;

    if (isCustom) {
      headingEl.textContent = 'Request a custom';
      subheadingEl.innerHTML = 'Interested in something like <strong>' + escHtml(productTitle) + '</strong>? Leave your email and we\'ll reach out to coordinate the specifics with you!';
      subjectInput.value = `Custom Request: ${productTitle}`;
    } else {
      headingEl.textContent = 'Request this item';
      subheadingEl.innerHTML = 'Interested in <strong>' + escHtml(productTitle) + '</strong>? Leave your email and we\'ll let you know when it\'s back in stock or available to order.';
      subjectInput.value = `Item Request: ${productTitle}`;
    }

    // Reset state
    form.hidden = false;
    successEl.hidden = true;
    nameInput.value = '';
    nameError.hidden = true;
    emailInput.value = '';
    emailError.hidden = true;
    notesInput.value = '';
    resetSubmitButton();

    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Focus the first input after transition
    setTimeout(() => emailInput.focus(), 50);
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetSubmitButton() {
    submitLabel.hidden = false;
    submitSending.hidden = true;
  }

  // ------------------------------------------------------------------
  // Delegate clicks on any [data-request-item] button
  // ------------------------------------------------------------------

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-request-item]');
    if (trigger) {
      e.preventDefault();
      openModal(
        trigger.dataset.productTitle || 'this item',
        trigger.dataset.productHandle || '',
        'requestCustom' in trigger.dataset
      );
      return;
    }

    // Close on backdrop click
    if (e.target === overlay) closeModal();
  });

  // Close button
  overlay.querySelector('.request-item-close').addEventListener('click', closeModal);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  // ------------------------------------------------------------------
  // Product page: show/hide request button when variant changes
  // ------------------------------------------------------------------

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function ({ data: { variant } }) {
      document.querySelectorAll('[data-request-item-product-wrap]').forEach(function (wrap) {
        wrap.classList.toggle('hidden', variant.available !== false);
      });
    });
  }

  // ------------------------------------------------------------------
  // Disable Shop Pay / dynamic checkout when Add to Cart is disabled
  // ------------------------------------------------------------------

  function syncPaymentButton(submitBtn) {
    var buttons = submitBtn.closest('.product-form__buttons');
    if (!buttons) return;
    var soldOut = submitBtn.hasAttribute('disabled');

    var payBtn = buttons.querySelector('.shopify-payment-button');
    if (payBtn) payBtn.style.display = soldOut ? 'none' : '';

    var productInfo = submitBtn.closest('product-info') || document.querySelector('product-info');
    if (productInfo) {
      var installment = productInfo.querySelector('.installment');
      if (installment) installment.style.display = soldOut ? 'none' : '';
    }
  }

  document.querySelectorAll('.product-form__submit').forEach(function (submitBtn) {
    syncPaymentButton(submitBtn);
    new MutationObserver(function () {
      syncPaymentButton(submitBtn);
    }).observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
  });

  // ------------------------------------------------------------------
  // Form submission via fetch → Shopify /contact
  // ------------------------------------------------------------------

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Validate name
    let hasError = false;
    if (!nameInput.value.trim()) {
      nameError.hidden = false;
      if (!hasError) { nameInput.focus(); hasError = true; }
    } else {
      nameError.hidden = true;
    }

    // Validate email
    if (!emailInput.validity.valid) {
      emailError.hidden = false;
      if (!hasError) { emailInput.focus(); hasError = true; }
    } else {
      emailError.hidden = true;
    }

    if (hasError) return;

    // Build body with optional notes
    const notes = notesInput.value.trim();
    const isCustom = headingEl.textContent === 'Request a custom';
    if (isCustom) {
      bodyInput.value = `Hi! I'm interested in a custom similar to "${currentProductTitle}". Please reach out to coordinate the details.${notes ? '\n\nNotes: ' + notes : ''} Thanks!`;
    } else {
      bodyInput.value = `Hi! I'd love to request "${currentProductTitle}". Please let me know when it's available or can be made to order.${notes ? '\n\nNotes: ' + notes : ''} Thanks!`;
    }

    submitLabel.hidden = true;
    submitSending.hidden = false;

    const data = new FormData(form);

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    })
      .then(function (res) {
        if (res.ok || res.redirected) {
          // Success (Shopify redirects on success, fetch follows)
          form.hidden = true;
          successEl.hidden = false;
        } else {
          throw new Error('Request failed');
        }
      })
      .catch(function () {
        // Fallback: treat any network error gracefully
        form.hidden = true;
        successEl.hidden = false;
      });
  });
})();
